// Directive for autoNumeric.js
// Require AngularJS, jQuery and autoNumeric.js
// https://gist.github.com/kwokhou/5964296
// Options - see:
// https://github.com/BobKnothe/autoNumeric
angular.module('cfn').directive('cfnNumeric', [
  '$locale',
  function($locale) {
    'use strict';
    // Declare a empty options object
    var options = {};
    return {
      // Require ng-model in the element attribute for watching changes.
      require: '?ngModel',
      // This directive only works when used in element's attribute (e.g: cfnNumeric)
      restrict: 'A',
      compile: function(tElm, tAttrs) {
        var isTextInput = tElm.is('input:text');

        return function(scope, elm, attrs, controller) {
          // Get instance-specific options.
          var opts = angular.extend(
            {
              aSep: $locale.NUMBER_FORMATS.GROUP_SEP,
              aDec: $locale.NUMBER_FORMATS.DECIMAL_SEP,
              mDec: 2,
              vMin: '0',
              pSign: 's'
            },
            options,
            scope.$eval(attrs.cfnNumeric)
          );

          if (attrs.symbolPost) {
            opts = angular.extend(opts, { aSign: ' ' + attrs.symbolPost });
          }
          if (attrs.decimal) {
            opts = angular.extend(opts, { mDec: attrs.decimal });
          }

          //if (attrs.decimalsOnFocus) {
          //    elm.on("focus", function (e) {
          //        scope.$apply(function () {
          //            elm.autoNumeric('update', { mDec: attrs.decimalsOnFocus });
          //        });
          //    }).on("blur", function (e) {
          //        scope.$apply(function () {
          //            elm.autoNumeric('update', { mDec: attrs.decimal | 2 });
          //        });
          //    });
          //}

          // Helper method to update autoNumeric with new value.
          var updateElement = function(element, newVal) {
            // Only set value if value is numeric
            if ($.isNumeric(newVal)) element.autoNumeric('set', newVal);

            if (attrs.emptyIfNull=="true" && newVal === null) {
              element.value = '';
            }
          };

          // Initialize element as autoNumeric with options.
          elm.autoNumeric(opts);
          elm.addClass('inputNumeric');

          // leave element empty if attribute emptyIfNull="true"
          if (attrs.emptyIfNull!=="true") {
            elm.autoNumeric('set', 0);
          }

          // if element has controller, wire it (only for <input type="text" />)
          if (controller && isTextInput) {
            // watch for external changes to model and re-render element
            scope.$watch(tAttrs.ngModel, function(current, old) {
              controller.$render();
            });
            // watch for changes on attributes
            attrs.$observe('symbolPost', function(val) {
              /*  an dieser Stelle wird, wenn ein <input>-Feld mit der Prop cfn-numeric
                    	 *  aufgerufen wird, nicht richtig initialisiert, wenn dieses <input>-Feld
                    	 *  als innerHtml innerhalb <cfn-column-new> aufgerufen wird.
                    	 *
                    	 *  Daher dann explizit elm.autoNumeric('init', {options}) aufrufen,
                    	 *  was auch bei mehrmaligen Aufruf zu keinen Problemen führen dürfte.
                    	 */
              elm.autoNumeric('init', opts); //

              elm.autoNumeric('update', { aSign: val ? ' ' + val : undefined });
            });
            // render element as autoNumeric
            controller.$render = function() {
              updateElement(elm, controller.$viewValue);
            };
            // Detect changes on element and update model.
            elm.on('change', function(e) {
              scope.$apply(function() {
                var v = elm.autoNumeric('get');
                v = parseFloat(v);
                controller.$setViewValue(v);
              });
            });
          } else {
            // Listen for changes to value changes and re-render element.
            // Useful when binding to a readonly input field.
            if (isTextInput) {
              attrs.$observe('value', function(val) {
                updateElement(elm, val);
              });
            }
          }
        };
      } // compile
    }; // return
  }
]);
